module.exports = __webpack_public_path__ + "media/images/iconTrendUp__accent-d07b92043091e0d60c3948b065b9e61d.png";